export default __webpack_public_path__ + "static/media/ic-info.f9a52475.svg";